import { Component, OnInit } from "@angular/core";
import { DefaultEditor } from "ng2-smart-table";

@Component({
  template: `
  <ngx-icon-selector vertical="true" [(icon)]="cell.newValue">
  `,
})
export class IconPropertyFieldComponent extends DefaultEditor implements OnInit{

  currentValue: any;

  ngOnInit(): void {
    //this.currentValue = this.cell.newValue.map(e => {return e.replaceAll("|","\\|")}).join("|")
    //console.log(this.currentValue)
  }

}
